// extracted by mini-css-extract-plugin
module.exports = {"infoBody":"app_infoBody___UIe2"};